import React, { useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
  buildCheckboxInput,
  buildMappingSelectInput,
  buildNumberInput,
  buildSelectInput, buildTextArea,
  buildTextInput
} from './form-inputs';

const CreateLiftoffMappingButton = ({title, fields, mappingData, onComplete, psa_instance, style}) => {
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();
  const formFields = fields.map(f => f.field);

  const cancel = () => {
    form.resetFields(formFields);
    setShowModal(false);
  };

  const submit = async () => {
    const completedForm = {};
    formFields.forEach(f => {
      completedForm[f] = form.getFieldValue(f);
    });
    if (psa_instance) {
      completedForm['PsaInstance'] = psa_instance;
    }

    onComplete(completedForm);
    setShowModal(false);
    form.resetFields();
  };

  return (<>
      <Button onClick={() => setShowModal(true)} icon={<PlusOutlined/>} style={style}>
        Create {title}
      </Button>

      {showModal && (<Form name={title} form={form} onFinish={submit} labelCol={{span: 7}}>
          <Modal
            title={`Create ${title} ${psa_instance ? `(${psa_instance})` : ''}`}
            width={700}
            open={showModal}
            onCancel={cancel}
            footer={[<Button key="cancel" onClick={cancel}>Cancel</Button>,
              <Button key="submit" type="primary" onClick={() => form.submit()}>
                Save
              </Button>]}
          >
            {fields.map(f => {
              switch (f.type) {
                case 'text':
                  return buildTextInput(f);
                case 'textarea':
                  return buildTextArea(f);
                case 'number':
                  return buildNumberInput(f);
                case 'checkbox':
                  return buildCheckboxInput(f);
                case 'select':
                  return buildSelectInput(f, false);
                case 'multiselect':
                  return buildSelectInput(f, true);
                case 'mapping':
                  return buildMappingSelectInput(mappingData, f, psa_instance);
                default:
                  return <></>;
              }
            })}
          </Modal>
        </Form>)}
    </>);
};

export { CreateLiftoffMappingButton };